export default {
    namespaced: true,
    state: {
        countries: null
    },
    getters: {
        countries: (state) => {
            return state.countries;
        }
    },
    actions: {

    },
    mutations: {
        countries (state, countries) {
            state.countries = countries;
        }
    }
}